import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { Global } from '../lib/global';

@Pipe({ name: 'documents' })
export class DocumentsPipe implements PipeTransform {

  public linkStream: string;

  constructor(
    private domSanitizer: DomSanitizer,
    public global: Global
  ) {
    this.linkStream = this.global.loggedUser().link;
  }

  transform(item: any, args: string) {
    if (args === 'cover') {
      return `url('${this.getCover(item)}')`;
    }
    if (args === 'link') {
      return this.getLink(item.arquivo);
    }
    return '';
  }

  getCover(item: any): string {
    const urlCheck = '/';
    const urlCheck2 = 'firebasestorage';
    const urlCheck3 = 'twcreativs';

    if (item.arquivo.includes(urlCheck) === true) {
      if (item.capa != null && item.capa.includes(urlCheck2)) {
        return item.capa;
      } else {
        return this.getVideo(item.arquivo);
      }
    } else if (item.capa != null) {
      if (item.capa.includes(urlCheck3)) {
        return this.getVideo(item.capa.split('/')[5]);
      } else {
        return item.capa;
      }
    }

    return this.getVideo(item.arquivo);
  }


  getLink(file: string): string {
    const extension = file.split('.').pop().replace('"', '').replace('"', '');
    const url = file.replace('"', '').replace('"', '');

    if (extension === 'jpg' || extension === 'png' || extension === 'gif') {
      return file;
    }

    if (!this.isUrl(file)) {
      return this.linkStream + 'videos/' + url + '/480';
    }

    const urlCheck2 = 'twcreativs.stream';

    if (url.includes(urlCheck2)) {
      return this.linkStream + 'videos/' + this.getVideoId(url) + '/480';
    }

    return url;

  }

  getVideoId(url: string): string {
    const split = url.split('/');
    return split[4];
  }

  isUrl(s: string): boolean {
    const regexp = /[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;
    return regexp.test(s);
  }

  getVideo(url: string): string {
    return this.linkStream + 'videos/thumb/' + url;
  }


}



// WEBPACK FOOTER //
// ./src/app/@core/pipes/documents.pipe.ts